import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { HttpService } from "src/service/http.service";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";

@Component({
  selector: "app-create-batch",
  templateUrl: "./create-batch.component.html",
  styleUrls: ["./create-batch.component.css"],
})
export class CreateBatchComponent implements OnInit {
  form: FormGroup;
  orders = [
    {
      name: "Automatic",
      id: 1,
    },
    {
      name: "Manual",
      id: 2,
    },
  ];
  title = "XLSRead";
  file: File;
  arrayBuffer: any;
  filelist: any = [];
  selectedOption: any;
  isSubmitted = false;
  model: any = {};
  isLoading!: boolean;
  ngForm: any;
  fieldTextType!: boolean;

  formRegister: FormGroup;
  // isSubmitted = false;
  fieldTextType1!: boolean;
  userName: any;
  isUser: any;
  isShowMessage: boolean = true;
  organizations: any;
  userExists: any;
  formRegisterOrg: FormGroup;
  activeColor: string = "green";
  baseColor: string = "#ccc";
  overlayColor: string = "rgba(255,255,255,0.5)";

  dragging: boolean = false;
  loaded: boolean = false;
  imageLoaded: boolean = false;
  imageSrc: string | undefined;
  filename: any;
  isSubmittedOrg: boolean = false;

  arraylist: any = [];
  formContainerUpload: FormGroup;
  radioForm: FormGroup;

  selectedDivision: string;
  challanList: any;
  totalLength: any;
  formatStatus: Boolean = false;
  factory_container_no: any;
  selectedDivisionValue: any;
  challanName: any;
  yearList: any;
  divisionsList: any;
  _challanNumber: any;
  batchId: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private httpService: HttpService
  ) {
    this.formContainerUpload = this.formBuilder.group({
      year: ["", [Validators.required]],
      challan: ["", [Validators.required]],
      division: ["", [Validators.required]],
      type: [""],
      challanName: ["", [Validators.required]],
      challan_count: ["", [Validators.required]],
    });
    this.radioForm = this.formBuilder.group({
      batchProcess: [""],
    });
    this.radioForm.patchValue({ batchProcess: "Automatic" });
  }
  dynamicArray: Array<any> = [];
  newDynamic: any = {};

  ngOnInit(): void {
    this.newDynamic = {
      bagNumber: "",
      class: "",
      netWeight: "",
      grossWeight: "",
    };
    this.dynamicArray.push(this.newDynamic);

    this.getChallansList();
    this.getDivisionsList();
    this.getCropsYearsList();
  }
  getUniqChallanNumber() {
    const body = [
      {
        _methodId: "4",
        _crop_year: this.formContainerUpload.value.year,
        _division_id: this.formContainerUpload.value.division,
        _challan_id: this.formContainerUpload.value.challanName,
        _userId: localStorage.getItem("uuid"),
      },
    ];
    this.httpService.generateUniqueChallanNo(body).subscribe((result) => {
      this._challanNumber = result["responseData"][1][0]["ChallanNumber"];
      if (
        this._challanNumber &&
        this.radioForm.value.batchProcess === "Manual"
      ) {
        this.createManualContainer();
      }
      if (
        this._challanNumber &&
        this.radioForm.value.batchProcess === "Automatic"
      ) {
        this.createAutomaticContainer();
      }
    });
  }
  getChallansList() {
    const body = [
      {
        _methodId: "1",
        _userId: localStorage.getItem("uuid"),
      },
    ];
    this.httpService.getChallansList(body).subscribe((challans) => {
      this.challanList = challans["responseData"][1];
    });
  }
  getDivisionsList() {
    const body = [
      {
        _methodId: "2",
        _userId: localStorage.getItem("uuid"),
      },
    ];
    this.httpService.getDivisionsList(body).subscribe((divisions) => {
      this.divisionsList = divisions["responseData"][1];
    });
  }

  getCropsYearsList() {
    const body = [
      {
        _methodId: "5",
        _userId: localStorage.getItem("uuid"),
      },
    ];
    this.httpService.getCropYearsList(body).subscribe((cropYears) => {
      this.yearList = cropYears["responseData"][1];
    });
  }

  deleteFile() {
    this.file = null;
    this.filelist = [];
    this.showFileUploadError = false;
  }
  getChallanCount(event) {
    let challanCount: any;
    this.challanList.forEach((element) => {
      if (parseInt(event.target.value) === element.challan_id) {
        challanCount = element.challan_count;
        this.challanName = element.challan_name;
      }
    });
    this.totalLength = challanCount;

    this.formContainerUpload.patchValue({ challan_count: challanCount });
  }
  onOptionsSelectedShopType(event: string) {
    const value = event;
    // this.selectedDivision=value;
    // console.log(this.selectedDivision)
    // const orgObj = {"organisation_id":localStorage.getItem('orgid')}

    // this.httpService.listChallanByOrganisationId(orgObj).subscribe(data=>{
    //   const challanData = data['data'];
    //   let challanCount:any;
    //   challanData.forEach(element => {
    //     if(parseInt(this.selectedDivision) === element.challan_id){
    //       challanCount = element.challan_count;
    //     }
    //   });
    //   this.formContainerUpload.patchValue({challan_count:challanCount})
    //   console.log(this.formContainerUpload)

    // })
  }
  onBatchProcess(event, batchName) {
    console.log(batchName);
  }
  handleDragEnter() {
    this.dragging = true;
  }

  handleDragLeave() {
    this.dragging = false;
  }

  handleDrop(e: any) {
    e.preventDefault();
    this.dragging = false;
    this.handleInputChange(e);
  }

  handleImageLoad() {
    this.imageLoaded = true;
  }
  addRow() {
    this.newDynamic = {
      bagNumber: "",
      class: "",
      netWeight: "",
      grossWeight: "",
    };
    this.dynamicArray.push(this.newDynamic);
    // this.toastr.success('New row added successfully', 'New Row');
    // console.log(this.dynamicArray);
    return true;
  }

  deleteRow(index) {
    if (this.dynamicArray.length == 1) {
      // this.toastr.error("Can't delete the row when there is only one row", 'Warning');
      return false;
    } else {
      this.dynamicArray.splice(index, 1);
      // this.toastr.warning('Row deleted successfully', 'Delete row');
      return true;
    }
  }
  showFileUploadError: any = false;

  handleInputChange(e: any) {
    /* try {
      this.formatStatus = false;
      var userid = localStorage.getItem('uuid');
      var orgid = localStorage.getItem('orgid');
      this.file = e.target.files[0];
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(this.file);
      fileReader.onload = (e) => {
        this.arrayBuffer = fileReader.result;
        var data = new Uint8Array(this.arrayBuffer);
        var arr = new Array();
        for (var i = 0; i != data.length; ++i)
          arr[i] = String.fromCharCode(data[i]);
        var bstr = arr.join("");
        var workbook = XLSX.read(bstr, { type: "binary" });
        var first_sheet_name = workbook.SheetNames[0];
        var worksheet = workbook.Sheets[first_sheet_name];
        // console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));
        this.arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
        // console.log(this.arraylist[0].class_of_opium);
        this.filelist = [];
        const cupAll = [];

        if (this.arraylist && this.arraylist.length === 0) {
          this.showFileUploadError = true;
        } else {
          this.showFileUploadError = false;
        }

        this.arraylist.forEach(item => {

          item['container_no'] = item['Bag Number'];

          item['class_of_opium'] = item['Class of Opium'];

          item['gross_weight'] = item['Gross Weight of Container (Kg.)'];

          item['net_weight'] = item['Net Weight of Opium (Kg.)'];




          delete item['Class of Opium'];

          delete item['Bag Number'];

          delete item['Gross Weight of Container (Kg.)'];

          delete item['Net Weight of Opium (Kg.)']

          if (item['container_no'] == undefined || item['class_of_opium'] == undefined || item['gross_weight'] == undefined || item['net_weight'] == undefined) {
            this.formatStatus = true;
          }
          else {
            this.formatStatus = false;
          }


        });
        if (this.formatStatus) {
          Swal.fire({
            html: `<h6 class="head">Error!<h6><h5 class="sub-head">File format is wrong</h5>`,

            icon: 'error',
            confirmButtonText: 'OK',
            customClass: {
              container: 'my-swal',
              confirmButton: 'your-confirm-button-class',

            }
          }).then((result) => {
          });

        }

        if (this.arraylist.length > this.formContainerUpload.value.challan_count) {
          Swal.fire({
            html: '<h2>Max number of containers for a GOOD challan is' + this.totalLength + ',Please check and try again<h2>',
            icon: 'error',
            confirmButtonText: 'OK',
          }).then((result) => {
          });
        }
        else {
          var factObj = {
            _crop_year: this.formContainerUpload.value.year,
            _division_id: Number(this.formContainerUpload.value.division),
            _challan_no:this.formContainerUpload.value.challan,
            _user_id: Number(localStorage.getItem('uuid'))
          }
          //
          this.httpService.getFactoryContainerNo(factObj).subscribe(factResult => {
           // console.log("fac" + factResult);

            this.factory_container_no = factResult.data[0].FactoryContainerNo;
            // alert(this.factory_container_no);
            for (let i = 0; i < this.arraylist.length; i++) {
              this.filelist.push([
                this.formContainerUpload.value.year,
                this.formContainerUpload.value.division,
                this.formContainerUpload.value.challan,
                this.arraylist[i].container_no,
                this.arraylist[i].class_of_opium,
                this.arraylist[i].net_weight,
                this.arraylist[i].gross_weight,
                userid,
                "Uploaded",
                userid,
                1,
                orgid,
                this.formContainerUpload.value.division,
                this.formContainerUpload.value.challanName,
                this.formContainerUpload.value.challan_count,
                this.factory_container_no
              ]);
              // this.filelist.push({
              //   "_crop_year": this.formContainerUpload.value.year,
              //   "_challan_no": this.formContainerUpload.value.challan,
              //   "_container_no": this.arraylist[i].container_no,
              //   "_class_of_opium": this.arraylist[i].class_of_opium,
              //   "_net_weight": this.arraylist[i].net_weight,
              //   "_gross_weight": this.arraylist[i].gross_weight,
              //   "_user_id": userid,
              //   "_stage_status": "Uploaded",
              //   "_status": 1,
              //   "_organisation_id": orgid,
              //   "_division_id": this.formContainerUpload.value.division,
              //   "_challan_id": String(this.formContainerUpload.value.challanName),
              //   "_no_of_containers": this.formContainerUpload.value.challan_count,
              // }
              // );
            }


          }, err => {
            console.log(err)
            alert(err.error.message);
          })

          this.formContainerUpload.patchValue({ challan_count: this.arraylist.length })

          //console.log([this.filelist]);
        }
      }
    }
    catch (err) {
      alert(err);
    }*/
  }

  _handleReaderLoaded(e: any) {
    //  console.log(e)
    var reader = e.target;

    this.imageSrc = (reader.result as string).split(",").pop();

    this.loaded = true;
  }

  downloadFile() {
    let link = document.createElement("a");
    link.download = "Challan-Creation-Sample-Sheet";
    link.href = "../../../../../assets/files/ChallanCreationSample.xlsx";
    link.click();
  }

  /*onSubmit() {
    if ((this.selectedDivisionValue === "18" || this.selectedDivisionValue === "19" || this.selectedDivisionValue === "20") && this.challanName === "25 GM SAMPLE") {
      if (this.arraylist.length > this.formContainerUpload.value.challan_count) {
        Swal.fire({
          html: '<h2>Max number of containers for a ' + this.challanName +' challan is' + this.totalLength + ',Please check and try again<h2>',
          icon: 'error',
          confirmButtonText: 'OK',
        }).then((result) => {
        });
      }
      else
      {
        this.challanCreate();
      }
     
    }
    else {
      if (this.selectedDivisionValue != "18" && this.selectedDivisionValue != "19" && this.selectedDivisionValue != "20" && this.challanName != "Choose Challan Type") {
        if (this.arraylist.length > this.formContainerUpload.value.challan_count) {
          Swal.fire({
            html: '<h2>Max number of containers for a ' + this.challanName +' challan is' + this.totalLength + ',Please check and try again<h2>',
            icon: 'error',
            confirmButtonText: 'OK',
          }).then((result) => {
          });
        }
        else
        {
          this.challanCreate();
        }
      }
      else {
        Swal.fire({
          html: `<h6 class="head">Error!<h6><h5 class="sub-head">this challan type not allowed !!</h5>`,

          icon: 'error',
          confirmButtonText: 'OK',
          customClass: {
            container: 'my-swal',
            confirmButton: 'your-confirm-button-class',

          }
        }).then((result) => {
        });
  
      }
    }
  }

  challanCreate() {
    if (this.formatStatus) {
      Swal.fire({
        html: `<h6 class="head">Error!<h6><h5 class="sub-head">File format is wrong,Please fix it.</h5>`,

        icon: 'error',
        confirmButtonText: 'OK',
        customClass: {
          container: 'my-swal',
          confirmButton: 'your-confirm-button-class',

        }
      }).then((result) => {
      });

    }
    else {
      this.isSubmitted = true;
      if (this.formContainerUpload.valid) {
        var userid = localStorage.getItem('uuid');
        var orgid = localStorage.getItem('orgid');

        if (this.radioForm.value.batchProcess === 'Manual' && this.dynamicArray.length > 0) {
          this.filelist = [];

          var factObj = {
            _crop_year: this.formContainerUpload.value.year,
            _division_id: Number(this.formContainerUpload.value.division),
            _challan_no: this.formContainerUpload.value.challan,
            _user_id: Number(localStorage.getItem('uuid'))
          }
          this.httpService.getFactoryContainerNo(factObj).subscribe(factResult => {
            //console.log("fac"+factResult);
            this.factory_container_no = factResult.data[0].FactoryContainerNo;
            for (let i = 0; i < this.dynamicArray.length; i++) {
              this.filelist.push([
                this.formContainerUpload.value.year,
                this.formContainerUpload.value.division,
                this.formContainerUpload.value.challan,
                this.dynamicArray[i].bagNumber,
                this.dynamicArray[i].class,
                this.dynamicArray[i].netWeight,
                this.dynamicArray[i].grossWeight,
                userid,
                "Uploaded",
                userid,
                1,
                orgid,
                this.formContainerUpload.value.division,
                this.formContainerUpload.value.challanName,
                this.dynamicArray.length,
                this.factory_container_no

              ]);
            
            }
          

            this.httpService.createContainer(this.filelist).subscribe(result => {
              if (Number(result.success) == 1) {
                Swal.fire({
                  html: '<h2>File Uploaded Successful ' + this.dynamicArray.length + ' records Created<h2>',
                  icon: 'success',
                  confirmButtonText: 'OK',
                }).then((result) => {
                  const data = {

                    "_stage_status": 'Uploaded',

                    "_location": 'null',

                    "_challan_no": this.formContainerUpload.value.challan,

                    "_crop_year": this.formContainerUpload.value.year,

                    "_division": this.formContainerUpload.value.division,

                    "_updatedby": Number(userid)

                  }

                  this.httpService.updateContainerStatus(data).subscribe(data => {
                    this.router.navigate(['/data-entry-challan-list'])
                  })
                });
              }
              else {
                Swal.fire({
                  html: '<h2>Error!<h2>',
                  icon: 'error',
                  confirmButtonText: 'Ok',
                }).then((result) => {
                  // this.router.navigate(['otp'])
                  this.formContainerUpload.reset();

                });
                // alert("Invalid Credentials!")
              }
            }, err => {
              console.log(err)
              alert(err.error.message);
            })
          }, err => {
            console.log(err)
            alert(err.error.message);
          })
        }
        else {
          if (this.filelist && this.filelist.length > 0) {
            this.httpService.createContainer(this.filelist).subscribe(result => {
              if (Number(result.success) == 1) {
                Swal.fire({
                  html: '<h2>File Uploaded Successful ' + this.formContainerUpload.value.challan_count + ' records Created<h2>',
                  icon: 'success',
                  confirmButtonText: 'OK',
                }).then((result) => {
                  this.router.navigate(['/data-entry-challan-list'])
                });
              }
              else {
                Swal.fire({
                  html: '<h2>Error!<h2>',
                  icon: 'error',
                  confirmButtonText: 'OK',
                }).then((result) => {
                  // this.router.navigate(['otp'])
                  this.formContainerUpload.reset();
                });
                // alert("Invalid Credentials!")
              }
            }, err => {
              //console.log(err.error.message);
              alert(err.error.message);
            })
          }
        }
      }
      else {
        alert("Errorcode");
      }
    }


  }*/

  onSubmit() {
    this.isSubmitted = true;
    if (
      this.radioForm.value.batchProcess === "Manual" &&
      this.formContainerUpload.valid &&
      this.dynamicArray &&
      this.dynamicArray.length > 0
    ) {
      this.getUniqChallanNumber();
    }
    if (
      this.radioForm.value.batchProcess === "Automatic" &&
      this.formContainerUpload.valid &&
      this.batchId
    ) {
      this.getUniqChallanNumber();
    }
  }
  createAutomaticContainer() {
    const body = [
      {
        _methodId: "9",
        _unChallan_No: this._challanNumber,
        _batchId: this.batchId,
        _userId: localStorage.getItem("uuid"),
      },
    ];
    Swal.fire({
      title: "Are you sure to continue",
      icon: "success",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      customClass: {
        container: "my-swal-two",
        confirmButton: "your-confirm-button-class-one",
        cancelButton: "your-cancel-button-class-one",
      },
    }).then((result) => {
      if (result.value) {
        this.httpService.addContainerAutomatic(body).subscribe((result1) => {
          if (result1.responseCode === 0) {
            Swal.fire({
              html: "<h6>Container Created Succesfully<h6>",
              icon: "success",
              confirmButtonText: "OK",
            }).then((result2) => {
              this.formContainerUpload.reset();
              this.isSubmitted = false;
              this._challanNumber = "";
              this.router.navigate(["/data-entry-challan-list"]);
            });
          } else {
            Swal.fire({
              html: "Error",
              icon: "error",
              confirmButtonText: "OK",
            }).then((result3) => {
              this.formContainerUpload.reset();
              this.isSubmitted = false;
              this._challanNumber = "";
              // this.router.navigate(['/data-entry-challan-list'])
            });
          }
        });
      }
    });
  }

  createManualContainer() {
    const body = [];

    this.dynamicArray.forEach((array) => {
      body.push([{
        _methodId: "6",
        _challanNumber: this._challanNumber,

        _divisionChallNumber: this.formContainerUpload.value.challan,
        _div_id: this.formContainerUpload.value.division,
        _challan_id: this.formContainerUpload.value.challanName,
        _div_unit: this.selectedDivisionUnit,
        _cropYear: this.formContainerUpload.value.year,
        _no_of_container: this.formContainerUpload.value.challan_count,
        _orgId: localStorage.getItem("orgid"),
        _bagNo: array.bagNumber,
        _opium_class: array.class,
        _netweight: array.netWeight,
        _gross_weight: array.grossWeight,
        _userId: localStorage.getItem("uuid"),
      }]);
    });

    Swal.fire({
      title: "Are you sure to continue",
      icon: "success",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      customClass: {
        container: "my-swal-two",
        confirmButton: "your-confirm-button-class-one",
        cancelButton: "your-cancel-button-class-one",
      },
    }).then((result) => {
      if (result.value) {

        if (body && body.length > 0) {
          body.forEach((element) => {
            this.httpService
              .addContainerManual(element)
              .subscribe((result1) => {
                if (result1.responseCode === 0) {
                  this.formContainerUpload.reset();
                  this.isSubmitted = false;
                  this._challanNumber = "";
                  this.selectedDivisionUnit = ''
                  this.router.navigate(["/data-entry-challan-list"]);
                }
              });
          });
        }
      }
    });
  }
  selectedDivisionUnit: any;
  onChangeDivision(deviceValue) {
    // console.log(deviceValue);
    this.selectedDivisionValue = deviceValue;
    // forEach(division=>{
    //   if(this.selectedDivision === division.division_id){

    //   }
    // })
    const selectedDivision = this.divisionsList.filter(
      (division) =>
        parseInt(this.selectedDivisionValue) === division.division_id
    );
    this.selectedDivisionUnit = selectedDivision[0].division_unit;
    console.log(this.selectedDivisionUnit);
  }
  changeInput(event) {
    console.log(event.target.files[0]);
    this.file = event.target.files[0];
    const formData = new FormData();
    formData.append("doc", this.file);
    formData.append("userId", localStorage.getItem("uuid"));
    formData.append("cropYear", this.formContainerUpload.value.year);
    formData.append("divisionId", this.formContainerUpload.value.division);
    formData.append("divChallaNumber", this.formContainerUpload.value.challan);
    formData.append("challanId", this.formContainerUpload.value.challanName);
    formData.append(
      "NoOfContainers",
      this.formContainerUpload.value.challan_count
    );
    formData.append("orgId", localStorage.getItem("orgid"));
    formData.append("divisionUnit", this.selectedDivisionUnit);
    this.httpService.fileUpload(formData).subscribe((result) => {
      console.log(result);
      if (result.responseCode === 1) {
        Swal.fire({
          html: `<h6>${result.responseData}<h6>`,
          icon: "error",
          confirmButtonText: "OK",
        }).then((result1) => {});
      } else {
        this.batchId = result["responseData"]["batchId"];
      }
    });
  }
}
